/**
 * 대시보드 페이지
 */

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Row, Col } from 'react-bootstrap';
import AdminLayout from '../../components/layout/AdminLayout';
import StatCard from '../../components/dashboard/StatCard';
import RevenueChart from '../../components/dashboard/RevenueChart';
import BookingChart from '../../components/dashboard/BookingChart';
import SalesChart from '../../components/dashboard/SalesChart';
import RecentActivity from '../../components/dashboard/RecentActivity';
import VoucherTicketStatus from '../../components/dashboard/VoucherTicketStatus';
import { dashboardService } from '../../services/dashboardService';

const Dashboard: React.FC = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['dashboard'],
    queryFn: () => dashboardService.getDashboardData(),
    refetchInterval: 60000, // 1분마다 자동 갱신
  });

  if (isLoading) {
    return (
      <AdminLayout>
        <div className="text-center py-5">
          <p style={{ color: '#fff' }}>로딩 중...</p>
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout>
        <div className="text-center py-5">
          <p style={{ color: '#f44336' }}>데이터를 불러오는 중 오류가 발생했습니다.</p>
        </div>
      </AdminLayout>
    );
  }

  const stats = data?.stats || {
    today_revenue: 0,
    today_bookings: 0,
    today_entrances: 0,
    pending_inquiries: 0,
    week_revenue: 0,
    week_bookings: 0,
    month_revenue: 0,
    month_bookings: 0,
  };

  return (
    <AdminLayout>
      <div>
        <h1 className="mb-4" style={{ color: '#fff' }}>대시보드</h1>
        
        {/* 주요 지표 위젯 */}
        <Row className="mb-4">
          <Col md={3} className="mb-3">
            <StatCard
              title="실시간 매출"
              value={stats.today_revenue}
              subtitle="오늘 기준"
              icon="💰"
            />
          </Col>
          <Col md={3} className="mb-3">
            <StatCard
              title="예약 현황"
              value={`${stats.today_bookings}건`}
              subtitle="오늘 기준"
              icon="📅"
            />
          </Col>
          <Col md={3} className="mb-3">
            <StatCard
              title="입장 현황"
              value={`${stats.today_entrances}명`}
              subtitle="오늘 기준"
              icon="🎫"
            />
          </Col>
          <Col md={3} className="mb-3">
            <StatCard
              title="고객 문의"
              value={`${stats.pending_inquiries}건`}
              subtitle="미처리 기준"
              icon="📝"
            />
          </Col>
        </Row>

        {/* 차트 섹션 */}
        <Row className="mb-4">
          <Col md={6} className="mb-3">
            <RevenueChart data={data?.revenue_trend || []} />
          </Col>
          <Col md={6} className="mb-3">
            <BookingChart data={data?.booking_trend || []} />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={12} className="mb-3">
            <SalesChart
              salesByHall={data?.sales_by_hall || []}
              salesByPackage={data?.sales_by_package || []}
            />
          </Col>
        </Row>

        {/* 바우처/티켓 실시간 현황 */}
        {data?.voucher_ticket_status && (
          <Row className="mb-4">
            <Col md={12} className="mb-3">
              <VoucherTicketStatus data={data.voucher_ticket_status} />
            </Col>
          </Row>
        )}

        {/* 최근 활동 */}
        <Row>
          <Col md={12}>
            <RecentActivity activities={data?.recent_activities || []} />
          </Col>
        </Row>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;

